export default "__VITE_ASSET__B0bzlUK4__"